export const AUTH_STEPS = {
  getStarted: "getStarted",
  emailLogin: "emailLogin",
  ssoLogin: "ssoLogin",
  signUp: "signUp",
  resetPassword: "resetPassword",
}
